import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../../components/Loader";
import { TOOL_URL } from "../Tool/constants";
import AggregatedDashboard from "./AggregatedDashboard";
import ClxStyleGuide from "./ClxStyleGuide";
import Cockpit from "./Cockpit";
import {
  CLX_STYLE_GUIDE_URL,
  CUSTOM_PUBLIC_GROUP_URL,
  CUSTOM_PUBLIC_REPORT_URL,
  DAS_TEST_URL,
  PUBLIC_COCKPIT_URL,
  PUBLIC_GROUP_URL,
  PUBLIC_REPORT_URL,
  PUBLIC_TEST_URL,
  TEST_GENERATOR_COCKPIT_CLX_INDIVIDUAL_REPORT_URL,
  TEST_GENERATOR_COCKPIT_CLX_URL,
  TEST_GENERATOR_COCKPIT_INDIVIDUAL_REPORT_URL,
  TEST_GENERATOR_COCKPIT_URL,
} from "./constants";
import CustomReports from "./CustomReports";
import "./index.scss";
import Test from "./Test";

const DualAssessment = lazy(() =>
  import("./DualAssesment").then(m => ({ default: m.DualAssessment }))
);
const CubeCockpit = lazy(() => import("./CubeCockpit"));
const CubeCockpitClx = lazy(() => import("./CubeCockpitClx"));
const IndividualReport = lazy(() =>
  import("./CubeCockpit/routes").then(m => ({ default: m.IndividualReport }))
);
const IndividualReportClx = lazy(() =>
  import("./CubeCockpitClx/routes").then(m => ({
    default: m.IndividualReport,
  }))
);

function Frontend() {
  return (
    <Routes>
      <Route index element={<Navigate to={TOOL_URL} replace />} />
      <Route path={`${PUBLIC_TEST_URL}/:testId/*`} element={<Test />} />
      <Route
        path={`${DAS_TEST_URL}/:testId/*`}
        element={
          <Suspense fallback={<Loader />}>
            <DualAssessment />
          </Suspense>
        }
      />
      <Route
        path={`${PUBLIC_REPORT_URL}/:entityId`}
        element={<AggregatedDashboard isGroup={false} />}
      />
      <Route
        path={`${PUBLIC_GROUP_URL}/:entityId`}
        element={<AggregatedDashboard isGroup={true} />}
      />
      <Route
        path={`${PUBLIC_COCKPIT_URL}/:clientId/:fieldId?`}
        element={<Cockpit />}
      />
      <Route
        path={`${TEST_GENERATOR_COCKPIT_URL}/:reportId/:clientId/:testId/*`}
        element={
          <Suspense fallback={<Loader />}>
            <CubeCockpit />
          </Suspense>
        }
      />
      <Route
        path={`${TEST_GENERATOR_COCKPIT_INDIVIDUAL_REPORT_URL}/:sessionId`}
        element={
          <Suspense fallback={<Loader />}>
            <IndividualReport />
          </Suspense>
        }
      />
      <Route
        path={`${TEST_GENERATOR_COCKPIT_CLX_URL}/:reportId/:clientId/:testId/*`}
        element={
          <Suspense fallback={<Loader />}>
            <CubeCockpitClx />
          </Suspense>
        }
      />
      <Route
        path={`${TEST_GENERATOR_COCKPIT_CLX_INDIVIDUAL_REPORT_URL}/:sessionId`}
        element={
          <Suspense fallback={<Loader />}>
            <IndividualReportClx />
          </Suspense>
        }
      />
      <Route
        path={`${CUSTOM_PUBLIC_REPORT_URL}/:entityId`}
        element={<CustomReports isGroup={false} />}
      />
      <Route
        path={`${CUSTOM_PUBLIC_GROUP_URL}/:entityId`}
        element={<CustomReports isGroup={true} />}
      />
      <Route path={CLX_STYLE_GUIDE_URL} element={<ClxStyleGuide />} />
    </Routes>
  );
}

export default Frontend;
